import React from 'react';
import PropTypes from 'prop-types';

import { ProductCardLoading } from './ProductCardLoading';
import { getRange } from '../../helpers/utilities';

export const ProductsGridLoading = ({ className }) => {
    return (
        <div className={className}>
            <div className="row">
                {getRange(1, 12).map((item) => (
                    <div key={item} className="col-sm-6 col-md-4 col-lg-3 mb-4">
                        <ProductCardLoading key={item} />
                    </div>
                ))}
            </div>
        </div>
    );
};

ProductsGridLoading.propTypes = {
    className: PropTypes.string
};
